import { getPps } from 'ACTIONS/categories/getPps';
import { API_URLS } from 'CONFIG/API_URLS';
import { PP_TYPE } from 'MODULES/PP_TYPE';

export const getExpiredLots = (id, path, activePage) => (dispatch) => {
    if (id) return dispatch(getPps(path, API_URLS.LOTS_EXPIRED_PLAN(id), PP_TYPE.expired, null, null, activePage, undefined, undefined, undefined, undefined, undefined, true));
    return null;
};
